module.exports = __webpack_public_path__ + "6f11f455e8d4f70c6e254fa3a6d682dc.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/arrow.png
// module id = ./app/images/arrow.png
// module chunks = 40